import { render } from "./EditStatements.vue?vue&type=template&id=2c19eab9&ts=true"
import script from "./EditStatements.ts?vue&type=script&lang=ts&external"
export * from "./EditStatements.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__